export const ORGANISATION_DROP_DOWN_KEY = "idwal-organisation_dropdown";

export const ADJUSTMENT_SUPPLEMENT_SUBTYPE = "Adjustment Supplement";
export const SURVEY_ELEMENT_TYPE_DOCUMENT = 1;
export const SURVEY_ELEMENT_TYPE_REPORT = 4;
export const SURVEY_ELEMENT_SLOT_FINAL = "final";
export const ID_INSPECTION_SNAPSHOT_SUBTYPE = "ID snapshot";
